// packages/app/src/api/users.ts
import toast from "react-hot-toast";
import { Payments } from "../../types";
import { baseUrl } from "./baseUrl";

// const BASE = import.meta.env.VITE_API_BASE_URL;

export async function fetchAllPayments(): Promise<Payments[]> {
  try {
    const res = await fetch(
        `${baseUrl}/admin/payments`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("admin_token")}`,
        },
      }
    );

    const payload = (await res.json()) as {
      success: boolean;
      message: string;
      data: Payments[];
    };

    if (!res.ok) {
      const m = payload.message?.toLowerCase?.();
      if (
        m === "invalid token" ||
        m === "jwt malformed" ||
        m === "jwt expired"
      ) {
        sessionStorage.removeItem("admin_token");
        toast.error("Invalid session");
        window.location.href = "/auth/sign-in";
        return Promise.reject(new Error("Unauthorized"));
      }
      throw new Error(m || `HTTP error! status: ${res.status}`);
    }

    if (!payload.success) {
      throw new Error(payload.message || "Failed to fetch users");
    }

    return payload.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}
